import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MerchantProfile } from '../_models';
import { CrudService } from './crud.service';

@Injectable()
export class MerchantProfileService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'merchant_profiles');
  }

  unarchive(id: number | string): Observable<MerchantProfile> {
    return this.http.post<MerchantProfile>(this.route + '/' + id.toString() + '/unarchive/', {});
  }
}
